<template lang="pug">
v-container(fluid) 
    v-card(color="#3557A5")  
        v-card-title(style="color:white") NO CONFORMIDADES - CERRADAS
        v-divider
        v-container(fluid)
            v-row  
                v-spacer
                v-col(cols=12 sm=12 md=2  style="min-width:200px!important")                                     
                    v-tooltip(bottom) 
                        template(v-slot:activator="{ on, attrs }")
                            v-card(height='100%'  v-bind="attrs" v-on="on" color="success"  dark).text-xs-center         
                                v-card-text     
                                    .display-1.mb-2 {{dtItems.length}}
                                    |  Cantidad No Conformidades 
                        span No Conformidades Generadas en el trascurso del año 
                v-col(cols=12 sm=12 md=2 style="min-width:200px!important")   
                    v-tooltip(bottom) 
                        template(v-slot:activator="{ on, attrs }")
                            v-card(height='100%'  v-bind="attrs" v-on="on" color="primary" dark @click="filterNext=filterNext==null ? 0:null; filterExpired=null;").text-xs-center         
                                v-card-text     
                                    .display-1.mb-2  {{dtItems.filter(b=> (b.Day>0)).length}}
                                    | Cierre en Plazo  
                        span No Conformidades por vencer
                v-col(cols=12 sm=12 md=2  style="min-width:200px!important")   
                    v-tooltip(bottom) 
                        template(v-slot:activator="{ on, attrs }")
                            v-card(height='100%'  v-bind="attrs" v-on="on" color="red" dark @click="filterExpired=filterExpired==null ? 0:null;filterNext=null;" ).text-xs-center         
                                v-card-text     
                                    .display-1.mb-2  {{dtItems.filter(b=>b.Day<0).length}}
                                    |  Fuera de Plazo 
                        span No Conformidades fuera de plazo
        v-container(fluid)
            v-toolbar(flat)
                v-toolbar-title              
                v-spacer
                v-text-field(
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details)
            v-toolbar(flat)
                v-toolbar-title
                    v-container(fluid)
                        v-row
                            v-col
                                v-autocomplete(  
                                                :items="columnValueList('TypeDocument')"
                                                hide-details="auto"
                                                v-model="filters['TypeDocument']"
                                                clearable
                                                dense
                                                label="Documento"
                                                outlined)
                            v-col
                                v-autocomplete(  
                                                :items="columnValueList('NumberDocument')"
                                                hide-details="auto"
                                                v-model="filters['NumberDocument']"
                                                clearable
                                                dense
                                                label="N°"
                                                outlined)
                            v-col
                                v-autocomplete(  
                                                :items="columnValueList('Category')"
                                                hide-details="auto"
                                                v-model="filters['Category']"
                                                clearable
                                                dense
                                                label="Categoria"
                                                outlined)  
                            v-col 
                                v-autocomplete(  
                                                :items="columnValueList('Responsible')"
                                                hide-details="auto"
                                                v-model="filters['Responsible']"
                                                clearable
                                                dense
                                                label="Responsable"
                                                outlined)      
                            v-col   
                                v-btn(  
                                        class="ma-2"
                                        color="success"
                                        dark
                                        @click="GetDownloadReport()")
                                    v-icon  mdi-cloud-download   
            v-data-table(:headers="dtHead"
                        dense
                        :items="ItemsFilters.filter(b => (filterNext==null && filterExpired==null) || (filterExpired!=null && b.Day<0) || (filterNext!=null && b.Day>=0) )",
                        :items-per-page="50" 
                        class="elevation-3" 
                        item-key="Id"  
                        :search="search"
                        :loading="dtLoading"
                        loading-text="Cargando Informacion......"
                        height="500"
                        class="elevation-2"
                        fixed-header
                        fixed-append)  
                template(v-slot:top="{top}") 
                               
                template( v-slot:item.DateFinish="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;") 
                        | {{ item.DateFinish | formatDate }}
                template( v-slot:item.DateClousure="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;") 
                        | {{ item.DateClousure | formatDate }}               
                template( v-slot:item.TypeDocument="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;padding-top: 5px!important;")  
                        v-chip(color="success" outlined) {{item.TypeDocument}}  
                template( v-slot:item.action="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;") 
                        v-row             
                            v-btn(icon  color="success"  @click="Closed(item.IdDocumentDetails)" )
                                v-icon mdi-lock-check 
                template( v-slot:item.Day="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;padding-top: 5px!important;")  
                        v-chip(v-if="item.Day>=0" color="success" outlined) {{item.Day}} 
                        v-chip(v-else color="error" outlined) {{item.Day}}  
                template( v-slot:item.img="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;") 
                        v-row             
                            v-btn(icon   @click="OpenImg(item.IdDocumentDetails,'evidence')" )
                                v-icon mdi-image
                template( v-slot:item.imgClose="{item}") 
                    td( style="text-align:left; vertical-align: text-top!important;") 
                        v-row             
                            v-btn(icon   @click="OpenImg(item.IdDocumentDetails,'close')" )
                                v-icon mdi-image 
        v-dialog(v-if="modelImg" 
                v-model="modelImg"
                width="400" 
                transition="dialog-bottom-transition" )

            v-card(style="width:400px") 
                v-toolbar(flat) 
                    v-spacer 
                    v-btn(icon @click="modelImg=false" )
                        v-icon mdi-close  
                v-container(fluid)       
                    v-img( width="300" 
                            :src="'data:image/jpg;base64,'+ imgSelect.replace('data:image/png;base64,','').replace('data:image/jpeg;base64,','')"  
                            cover
                            )                              
</template>
<script>  
import apiWeb from "../../../../api/apiSLC.js"
import modelClousure from "../../../../models/documentDetailsClousure.js" 
import * as XLSX from 'xlsx/xlsx.mjs'
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
export default {
    components : { 
        
    },
    props:['refresh'],
    watch:{
        refresh(value,old){
            if(value!=old){
                console.log(value)
                console.log(old)
                this.GetList()
            }
            
        }
    },
    data(){
        return{ 
            modelImg:false,
            modelClose:false,
            parameterClousureInsert:Object.assign({}, modelClousure.parameterInsert),
            itemSelect:{},
            imgSelect:'',
            dtItems:[],
            search:'', 
            filterNext:null,
            filterExpired:null,
            Img:'',        
            dtLoading:true,
            Indicadores:'',
            filters:{},
            dtHead:[                     
                    { text: "N° Documento", value: "NumberDocument",  width:"50",  cellClass:'topStyle', class: 'topStyle'},
                    { text: "Documento", value: "TypeDocument",  width:"100",  cellClass:'topStyle', class: 'topStyle'},
                    { text: "Categoria", value: "Category",  width:"100",  cellClass:'topStyle', class: 'topStyle'},
                    { text: "Grupo", value: "GroupQuestions",  width:"100",   cellClass:'topStyle',class: 'topStyle'},
                    { text: "Pregunta", value: "Question",  width:"200" ,    cellClass:'topStyle',class: 'topStyle'},
                    { text: "Observacion", value: "Observation",  width:"200" ,   cellClass:'topStyle',class: 'topStyle'},                    
                    { text: "Responsable", value: "Responsible",  width:"100",   cellClass:'topStyle',class: 'topStyle'},
                    { text: "Img", value: "img",   width:"10" ,   cellClass:'topStyle',class: 'topStyle'}, 
                    { text: "Fecha de Finalizacion", value: "DateFinish",  width:"50",   cellClass:'topStyle',class: 'topStyle'},
                    { text: "Observacion Cierre", value: "ObservationClousure",  width:"200" ,   cellClass:'topStyle',class: 'topStyle'}, 
                    { text: "Img cierre", value: "imgClose",   width:"10" ,   cellClass:'topStyle',class: 'topStyle'}, 
                    { text: "Fecha de Cierre", value: "DateClousure",  width:"50",   cellClass:'topStyle',class: 'topStyle'},
                    { text: "Atraso (Dias)", value: "Day",  width:"50",   cellClass:'topStyle',class: 'topStyle'},
                    { text: "Usuario", value: "User",  width:"70",  cellClass:'topStyle', class: 'topStyle'}
                    ], 
        }
    },
    mounted(){
        this.GetList() 
    },
    computed: {
        ItemsFilters() {
        return this.dtItems.filter(d => {
            return Object.keys(this.filters).every(f => {  
                if(this.filters[f]==null)
                    return true
                else{ 
                    if(d[f]!=null)
                        return this.filters[f].toString().length < 1 || this.filters[f].toString().includes(d[f].toString())
                    else
                        return false
                }})
        })
        }   
    },
    methods:{ 
        columnValueList(val) {
            return this.ItemsFilters.map(d => d[val])
        },
        OpenImg(docentry,type){ 
            let form = {
                IdDocumentDetails:docentry  
            }
            apiWeb.post("NonConformities/NonConformities_Img",form,true).then( result => {
                if(result.status==0){
                    let _result=JSON.parse(result.value)
                    this.imgSelect= type=='evidence' ?  _result[0].Img : _result[0].ImgClousure
                    this.modelImg=true
                }   
                    
               
            })
        }, 
        GetList(){ 
            this.dtLoading=true 
            let form = {
                IdEnterprise:this.$info.idEnterprise  ,
                User:this.$info.email,
            }
            apiWeb.post("NonConformities/NonConformities_Closed",form,false).then( result => {
                if(result.status==0)   
                    this.dtItems=JSON.parse(result.value)
                this.dtLoading=false
            })
        },  
       GetDownloadReport(){ 
        let form = {
                IdEnterprise:this.$info.idEnterprise  ,
                User:this.$info.email,
            }
            apiWeb.post("NonConformities/NonConformities_Closed",form,true)
                    .then(element=>{
                        if(element.status==0)   
                            this.exportToExcel(JSON.parse(element.value),'Reporte Pendientes')

                    })
        },
        DownloadExcel(Info,title){
            var ws = XLSX.utils.json_to_sheet(Info);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, title);
            XLSX.writeFile(wb, title + ".xlsx");
        },
        async exportToExcel(Info,title) {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');

            // Agrega encabezados
            const headers = Object.keys(Info[0]);
            worksheet.columns = headers.map(header => ({ header, key: header, width: 30 }));

            // Agrega datos y las imágenes a las celdas
            for (let i = 0; i < Info.length; i++) {
                const item = Info[i];
                const row = worksheet.addRow(item);

                // Agrega la imagen si existe en la columna 'Img'
                if (item.Img) {
                const imageId = workbook.addImage({
                    base64: item.Img,
                    extension: 'png',
                });
                worksheet.addImage(imageId, {
                    tl: { col: headers.indexOf('img'), row: row.number - 1 },
                    ext: { width: 50, height: 50 }
                });
                }
            }

      // Genera el archivo Excel y lo descarga
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), 'tabla.xlsx');
            }
    }
}

</script>
<style >
.colorTest{
    background-color:#0099CC!important;
    color:white!important;
}
.topStyle{
    padding-top: 5px!important;
    vertical-align: text-top!important;
} 
</style>